var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkRedirectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34107 2.845L2.16857 10.0175L0.990234 8.83917L8.1619 1.66667H1.84107V0H11.0077V9.16667H9.34107V2.845Z",
    fill: "#121B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkRedirectArrow);
export default __webpack_public_path__ + "static/media/link_redirect_arrow.4dd4acdca0beaf36a5499c7be579f0a3.svg";
export { ForwardRef as ReactComponent };